import { AUTH_HEADER } from '@/core/constants/http-headers'
import { safeParseFloat } from '@/core/lib/utils/parse-float'
import { IHttpClient } from '@/core/services/http'
import { ITokenService } from '@/core/services/tokens/token.service.interface'
import { UnauthorizedError } from '@/core/types/errors/http-error'
import { ID } from '@/core/types/models/id.model'
import { RefundResponse } from '../types/api-responses/refund-details-response'
import { RefundModel } from '../types/models/refund.model'

export function createAskForRefundUseCase({
  httpClient,
  tokenService,
}: {
  httpClient: IHttpClient
  tokenService: ITokenService
}) {
  return async function (tripId: ID) {
    const { token, accountType } = await tokenService.getToken()
    if (!token) {
      throw new UnauthorizedError()
    }
    try {
      const res = await httpClient
        .version('v1')
        .addHeaders(AUTH_HEADER(token))
        .get<{
          data: RefundResponse
        }>(`website/${accountType}/askForRefundUpdate/${tripId}`)

      return resolver(res.data.data)
    } catch (_) {
      return { bankAccount: 0, wallet: 0 }
    }
  }
}

function resolver(res: RefundResponse): RefundModel {
  return {
    wallet: safeParseFloat(res.wallet),
    bankAccount: safeParseFloat(res.stripe),
  }
}
